import LandingPage from "@/components/LandingPage";

const internal = [
  { label: "Videoproduktion Bochum", to: "/videoproduktion-bochum" },
  { label: "Videoproduktion NRW", to: "/videoproduktion-nrw" },
  { label: "Eventfilm & Aftermovie", to: "/eventfilm" },
  { label: "Sport-Content", to: "/sport-content" },
  { label: "Alle Leistungen", to: "/leistungen" },
];

const ImagefilmBochum = () => (
  <LandingPage
    path="/imagefilm-bochum"
    metaTitle="Imagefilm Bochum | Cinematic Imagefilm-Agentur 4Facemedia"
    metaDescription="Imagefilm aus Bochum: cinematic, strategisch & conversion-stark. Wir produzieren Imagefilme für Unternehmen im Ruhrgebiet & deutschlandweit. Jetzt anfragen."
    eyebrow="Imagefilm · Bochum · Ruhrgebiet"
    h1={
      <>
        Imagefilm <span className="text-gradient">aus Bochum</span>.
      </>
    }
    intro="Ein Imagefilm, der nicht nur schön aussieht, sondern verkauft. Wir entwickeln Imagefilme für Unternehmen aus Bochum & dem Ruhrgebiet – mit klarer Story, cinematic Bildsprache & messbarem Ergebnis."
    serviceName="Imagefilm Bochum"
    serviceDescription="Cinematic Imagefilm-Produktion mit Sitz in Bochum. Strategisch entwickelte Imagefilme für Unternehmen, Marken & Institutionen im Ruhrgebiet und deutschlandweit."
    areaServed={["Bochum", "Dortmund", "Essen", "Herne", "Witten", "Ruhrgebiet", "Nordrhein-Westfalen", "Deutschland"]}
    bullets={[
      { title: "Story first", text: "Wir starten nicht mit der Kamera, sondern mit eurer Story. Warum gibt es euch, für wen, was ist anders?" },
      { title: "Cinematic Bildsprache", text: "Kinoreife Optik mit professionellem Licht, Color Grading und Sound-Design – kein YouTube-Look." },
      { title: "Strategisch gedacht", text: "Jeder Imagefilm bekommt ein klares Ziel: Recruiting, Sales, Investor-Pitch oder Markenaufbau." },
      { title: "Lokal in Bochum verankert", text: "Kurze Wege im Ruhrgebiet, schnelle Drehs, persönliche Betreuung statt Agentur-Pingpong." },
      { title: "Mehrfachverwertung inklusive", text: "Aus jedem Imagefilm liefern wir Cutdowns für Social, Web & Sales – ein Dreh, mehrere Assets." },
      { title: "Planbar & transparent", text: "Festpreis-Angebote, klare Milestones und ein dokumentierter Workflow vom Briefing bis zur Auslieferung." },
    ]}
    faqs={[
      { q: "Was kostet ein Imagefilm in Bochum?", a: "Solide Imagefilme starten bei ca. 4.500 €. Der Endpreis hängt von Drehtagen, Locations, Schauspielern und Postproduktion ab – wir machen ein transparentes Festpreis-Angebot nach kurzem Briefing." },
      { q: "Wie lange dauert die Produktion eines Imagefilms?", a: "Von Briefing bis Auslieferung rechnen wir typisch mit 4–8 Wochen. Bei klar definiertem Konzept geht es auch schneller, bei größeren Produktionen entsprechend länger." },
      { q: "Wie lang sollte ein Imagefilm sein?", a: "Für die Website empfehlen wir 60–120 Sekunden, für Social Media 15–30 Sekunden Cutdowns. Wir produzieren in der Regel eine Hauptversion plus mehrere Kurzversionen." },
      { q: "Übernehmt ihr auch Konzept und Drehbuch?", a: "Ja. Konzept, Drehbuch, Storyboard, Casting, Locationscouting, Dreh, Schnitt, Color Grading und Sound-Design – alles aus einer Hand." },
      { q: "Dreht ihr nur in Bochum?", a: "Nein. Bochum ist unser Sitz, gedreht wird bundesweit. Reisetage werden im Angebot transparent ausgewiesen." },
    ]}
    internalLinks={internal}
  />
);

export default ImagefilmBochum;
